import { makeStyles, createStyles } from '@material-ui/core'

export const styles = theme => createStyles({
  container: {
    padding: '20px 0'
  }
})

export default makeStyles(styles)